export default window.moment || function(){};
